module.exports = __webpack_public_path__ + "static/img/logo.e0a0b312.svg";